var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apple",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21394",
    "data-name": "Group 21394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    fill: "#fff",
    stroke: "#e1e7ee",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 53,
    rx: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 52,
    rx: 16.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Stockholm_icons_Communication_Active_call",
    "data-name": "Stockholm icons / Communication / Active call",
    transform: "translate(10 11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Stockholm_icons_Communication_Active_call_Background_",
    "data-name": "Stockholm icons / Communication / Active call (Background)",
    width: 32,
    height: 32,
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Apple_logo",
    transform: "translate(6.786 3.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "apple_2_",
    d: "M88.4,8.5a4.667,4.667,0,0,0,1.2-3.061A3.94,3.94,0,0,0,89.576,5a4.61,4.61,0,0,0-1.769.5A4.887,4.887,0,0,0,86.26,6.661a4.8,4.8,0,0,0-1.269,3.094,3.4,3.4,0,0,0,.025.414A4.076,4.076,0,0,0,88.4,8.5Z",
    transform: "translate(-75.778 -4.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "apple_1_",
    d: "M33.685,53.226a4.784,4.784,0,0,1,.928-7.667,5.289,5.289,0,0,0-4.143-2.181,6.057,6.057,0,0,0-2.491.442,9.889,9.889,0,0,1-1.832.572,6.7,6.7,0,0,1-1.653-.486,6.343,6.343,0,0,0-2.084-.485,5.36,5.36,0,0,0-2.694.76A5.581,5.581,0,0,0,17.723,46.2a7.245,7.245,0,0,0-.951,3.79,12.187,12.187,0,0,0,.7,3.967,13.111,13.111,0,0,0,1.676,3.329,11.279,11.279,0,0,0,1.585,1.9,2.769,2.769,0,0,0,1.991.88,5.358,5.358,0,0,0,1.721-.452,5.334,5.334,0,0,1,1.991-.428,5.159,5.159,0,0,1,1.937.428,4.884,4.884,0,0,0,1.8.429,2.94,2.94,0,0,0,1.947-.858,10.745,10.745,0,0,0,1.515-1.831,11.9,11.9,0,0,0,1.176-2.115q.2-.486.386-1.014A4.978,4.978,0,0,1,33.685,53.226Z",
    transform: "translate(-16.772 -38.184)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.6c2d26ad9ecbad7e1db3c464c5013e30.svg";
export { ForwardRef as ReactComponent };